import { render, staticRenderFns } from "./data-form.vue?vue&type=template&id=5fc30457&scoped=true"
import script from "./data-form.vue?vue&type=script&lang=ts"
export * from "./data-form.vue?vue&type=script&lang=ts"
import style0 from "./data-form.vue?vue&type=style&index=0&id=5fc30457&prod&lang=less&scoped=true"
import style1 from "./data-form.vue?vue&type=style&index=1&id=5fc30457&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc30457",
  null
  
)

export default component.exports